exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mid-image[data-v-6bc2dc5a]{background:#000;height:90px;margin-bottom:10px;align-items:flex-end}#image img[data-v-6bc2dc5a]{width:100%}#social[data-v-6bc2dc5a]{margin-top:16px;background:#df9da9}#social img[data-v-6bc2dc5a]{width:100%}@media (min-width:992px){#image[data-v-6bc2dc5a]{margin-top:20px}}@media (max-width:768px){#image img[data-v-6bc2dc5a]{max-height:270px}}@media (max-width:576px){#image[data-v-6bc2dc5a]{margin-top:20px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6bc2dc5a","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/overall_layouts/sidebar-image.vue
// module id = 622
// module chunks = 0